import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

// Vant 按需引入（通过 babel-plugin-import 自动引入样式）
import {
  Button, NavBar, Tabbar, TabbarItem, Tab, Tabs,
  Swipe, SwipeItem, Grid, GridItem, Cell, CellGroup,
  Image as VanImage, Icon, Tag, Badge,
  List, PullRefresh, Empty,
  Form, Field, Picker, DatetimePicker, Popup,
  Stepper, Checkbox, CheckboxGroup, Radio, RadioGroup,
  Uploader, Rate, ActionSheet, Switch,
  Dialog, Toast, Notify,
  Loading, Overlay, Skeleton,
  Card, Divider, Steps, Step,
  Search, DropdownMenu, DropdownItem,
  CountDown, SwipeCell
} from 'vant'
import 'vant/lib/index.css'

const vantComponents = [
  Button, NavBar, Tabbar, TabbarItem, Tab, Tabs,
  Swipe, SwipeItem, Grid, GridItem, Cell, CellGroup,
  VanImage, Icon, Tag, Badge,
  List, PullRefresh, Empty,
  Form, Field, Picker, DatetimePicker, Popup,
  Stepper, Checkbox, CheckboxGroup, Radio, RadioGroup,
  Uploader, Rate, ActionSheet, Switch,
  Dialog, Toast, Notify,
  Loading, Overlay, Skeleton,
  Card, Divider, Steps, Step,
  Search, DropdownMenu, DropdownItem,
  CountDown, SwipeCell
]
vantComponents.forEach(c => Vue.use(c))

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

